// extracted by mini-css-extract-plugin
export default {"triggers":"Triggers_triggers__MxAYX"};